import { StyledUiContainerProps } from 'components';
import styled from 'styled-components';
import theme from 'common/theme';

/*
top:0;
  left: 100%;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  transition: opacity 200ms;
  
  &.is-open {
    left: 0;
    opacity: 1;

    &.is-flyout { 
      .popup-wrapper {
        transform: translateX(0);
      }
    }
  }
  */

export const FlyoutAndPopupsContainer = styled.div<StyledUiContainerProps>`
  top:0;
  left: 100%;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  transform: translateX(100%);
  opacity: 0;
  transition: opacity 200ms;

  .close-trigger {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  &.is-open {
    transform: translateX(0);
  }

  &.is-flyout .popup-wrapper {
    transform: translateY(100%);
    .popup-main {
      padding-right: .5em;
      margin-right: .5em;
      padding-left: 1em;
    }
  }

  &.is-open {
    opacity: 1;
    left: 0;

    &.is-flyout { 
      justify-content: flex-end;
      .popup-wrapper {
        transform: translateX(0);
       
      }
    }
  }

  @keyframes cover-in {
    0% {
      left: 100%;
      opacity: 0;
    }
    1% {
      left: 0;
      opacity: 0;
    }
    100% {
      left: 0;
      opacity: 1;
    }
  }

  @keyframes cover-out {
    0% {
      display: none
      opacity: 0;
    }
    2% {
      display: grid;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .popup-wrapper {
   box-shadow: 0 40px 50px rgba(0, 0, 0, 0.1);
    max-width: 80vw;
    width: max-content;
    background: white;
    display: grid;
    z-index: 1;
    border-radius: 1em;
    grid-template-rows: ${({ gridRows }) => gridRows || 'auto 1fr'};

    .popup-content {
      padding: 1em;
    }    
  }

  .popup-header {
    display: flex;
    justify-content: flex-end;
    color: ${theme.colors.jbtBlue};
  }

  .popup-title-bar {
    padding: 1em;
    grid-gap: 1em;
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;
    align-items: center;
   
    button.btn-close { 
      border: 0;
      background-color: transparent;
      cursor: pointer;
      display: flex;
      padding: .5em;
    }
  }

  .popup-title-bar__header {
    display: flex;
    width: 100%;
    align-items: center;
    h2 { 
      margin: 0;
      padding: 0;
      font-weight: 600;
      font-size: 1.4em;
      flex-grow: 1;
      display: flex;
    }
  }

  .popup-main {
    overflow-x: hidden;
    overflow-y: auto;
  }

  &.is-full-screen {
    .popup-wrapper {
      width: 100%;
    }
  }

  &.is-flyout {    
   
    .popup-wrapper {
      height: 100%;
      grid-column: 2;
      max-width: 40em;
    }
  }

  .popup-title-bar__header::first-letter {
    text-transform: capitalize;
  }

  &.is-centered,
  &.is-modal,
  &.is-full-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2.5em;

    .popup-wrapper {
      min-width: 33vw;
      box-shadow: ${theme.effects.boxShadow.dark};
    }
  }

  @keyframes flyout-in {
    0% {
      display: none
      transform: translateX(100%);
    }
    1% {
      display: grid;
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }

`;
